

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SearchAreaModel from '../models/SearchAreaModel'
import { bacSlideOverService } from 'bac-frontend-common'
import ComposeComment from '../components/composeComment.vue'
import CommentModel from '..//models/commentModel'
import { Getter } from 'vuex-class'

@Component({})
export default class Comments extends Vue {

    @Prop({})
    searchArea!: SearchAreaModel
    @Prop({ default: 'Comments:' })
    commentTitle !: String
    @Prop({ default: false })
    editControls !: Boolean

    comments: Array<CommentModel> = []

    @Getter('composeComment') composeCommentStore!: CommentModel;

    mounted () {
      this.comments = this.searchArea.comments
      // Subscribe to comment changes in store
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'pushComment' || mutation.type === 'removeComment') {
          this.comments = this.$store.getters['currentSearchArea'].comments
        }
      })
    }

    @Watch('searchArea', { immediate: true, deep: true })
    onSearchAreaChange (newVal: any) {
      this.comments = this.searchArea.comments
    }

    edit (comment: CommentModel, index: number) {
      this.composeCommentStore.setImg(comment.img)
      this.composeCommentStore.setText(comment.text)
      this.openSlideOver()
      this.deleteComment(index)
    }

    deleteComment (index: number) {
      this.$store.dispatch('deleteComment', index)
    }

    openSlideOver () {
      bacSlideOverService.openSlideOver({
        component: ComposeComment,
        data: { message: '' }
      })
    }
}
